import './newrelic.types';

const hasAgent = (): boolean => typeof window !== 'undefined' && typeof window.newrelic !== 'undefined';

export const noticeError = (error: Error, attributes?: Record<string, unknown>): void => {
	if (hasAgent()) {
		window.newrelic!.noticeError(error, attributes);
		return;
	}
	// eslint-disable-next-line no-console
	console.error(error, attributes);
};

export const addPageAction = (name: string, attributes?: Record<string, unknown>): void => {
	if (hasAgent()) {
		window.newrelic!.addPageAction(name, attributes);
		return;
	}
	// eslint-disable-next-line no-console
	console.info(`[pageAction] ${name}`, attributes);
};

export const setCurrentRouteName = (name: string): void => {
	if (hasAgent()) {
		window.newrelic!.setCurrentRouteName(name);
	}
};
